module.exports = __webpack_public_path__ + "img/Tutorial_blue.9dec8bb0.svg";